import { FC, useMemo } from 'react';
import { Button, Dropdown } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';
import { useFormContext } from 'react-hook-form';
import { DropdownItem } from '../../../../common/components';
import { AlgorithmGraphCta } from '../../AlgorithmGraphCta';
import {
  getDefaultAlgorithmMappingNode,
  getDefaultAlgorithmSourceNode,
} from '../schema/defaultValues';
import type { AlgorithmJoinsAndMappingsGraphValidFormDataType } from '../schema/types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmJoinsAndMappingsGraphCta.translations.json';
import { AlgorithmType } from '../../schema/zAlgorithmType';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-joins-and-mappings-graph-cta',
);
addTranslations(translations);

interface AlgorithmJoinsAndMappingsGraphCtaProps {
  algorithmType: AlgorithmType;
}
export const AlgorithmJoinsAndMappingsGraphCta: FC<
  AlgorithmJoinsAndMappingsGraphCtaProps
> = (props) => {
  const { algorithmType } = props;
  const { t } = useTranslation();

  const { setValue } =
    useFormContext<AlgorithmJoinsAndMappingsGraphValidFormDataType>();

  const menu = useMemo(() => {
    var items = [];
    if (algorithmType === AlgorithmType.INSERT) {
      items.push({
        key: 'join',
        label: <DropdownItem>{t('join')}</DropdownItem>,
      });
    }
    items.push({
      key: 'mapping',
      label: <DropdownItem>{t('mapping')}</DropdownItem>,
    });
    return {
      items,
      onClick: (info: MenuInfo) => {
        setValue(
          `nodes.0`,
          info.key === 'join'
            ? getDefaultAlgorithmSourceNode()
            : getDefaultAlgorithmMappingNode(),
          {
            shouldDirty: true,
          },
        );
      },
    };
  }, [algorithmType, setValue, t]);

  return (
    <AlgorithmGraphCta
      heading={t('cta')}
      button={
        <Dropdown trigger={['click']} menu={menu}>
          <Button id="algorithm-graph-cta" type="primary">
            {t('button.create-root-join')}
          </Button>
        </Dropdown>
      }
    />
  );
};
